// Source: hr-timeline.txt. All dates are 2026.
// To add an entry, append to TIMELINE. When the visa lands, set VISA_GRANTED_ON
// to that date and the page stops counting.

export const d = (month, day) => new Date(2026, month - 1, day);

export const START = d(7, 7);
export const VISA_GRANTED_ON = null; // e.g. d(12, 1)

// kind: 'ask' (I had to chase it), 'progress', 'stall', 'holiday', 'promise' (a date that slipped), 'milestone'
export const TIMELINE = [
  {
    date: d(7, 7),
    kind: 'milestone',
    title: 'The ask',
    text: 'I ask my boss Tom about relocating to Germany.',
    people: ['Tom'],
  },
  {
    date: d(8, 3),
    kind: 'ask',
    title: 'Nudge #1',
    text: "I ask Tom for an update. He says he'll follow up.",
    people: ['Tom'],
  },
  {
    date: d(8, 4),
    kind: 'progress',
    title: 'The visa question',
    text: "Tom asks whether I already have a visa. I can be sponsored by my spouse, but I wouldn't have one until I get a work contract from the German office, or until I move there and apply for residency.",
    people: ['Tom'],
  },
  {
    date: d(8, 17),
    kind: 'stall',
    title: 'A “no”',
    text: 'Tom gets a negative response. He starts a plan to pull strings with Simon.',
    people: ['Tom', 'Simon'],
  },
  {
    date: d(8, 18),
    kind: 'progress',
    title: 'Reinforcements',
    text: 'Tom loops in Jamie to get my request processed.',
    people: ['Tom', 'Jamie'],
  },
  {
    date: d(8, 28),
    kind: 'milestone',
    title: 'HR enters the chat',
    text: "Desiree emails me after a meeting with Tom. She's contacted a relocation agency to help process my request, and asks for my CV and college diploma.",
    people: ['Desiree', 'Tom'],
  },
  {
    date: d(8, 29),
    kind: 'progress',
    title: 'Documents sent',
    text: 'I send my CV and diploma to Desiree. Same day turnaround on my end.',
    people: ['Desiree'],
  },
  {
    date: d(8, 31),
    kind: 'holiday',
    title: 'Holiday #1',
    text: 'Desiree goes on a two-week holiday.',
    people: ['Desiree'],
  },
  {
    date: d(9, 10),
    kind: 'promise',
    title: '“2–3 weeks”',
    text: "I follow up with Desiree after her holiday. She says it'll take 2–3 weeks to get the work contract ready.",
    people: ['Desiree'],
  },
  {
    date: d(9, 23),
    kind: 'promise',
    title: '“Next week”',
    text: 'I follow up again. She asks for a couple more items and says the work contract will be ready next week.',
    people: ['Desiree'],
  },
  {
    date: d(10, 2),
    kind: 'progress',
    title: 'Salary alignment',
    text: 'Desiree meets with Tom to align on salary expectations.',
    people: ['Desiree', 'Tom'],
  },
  {
    date: d(10, 5),
    kind: 'progress',
    title: 'The offer',
    text: 'First call with Desiree and Daniel to discuss the package. They offer 105K EUR. I ask for 120K EUR.',
    people: ['Desiree', 'Daniel'],
  },
  {
    date: d(10, 8),
    kind: 'milestone',
    title: 'Deal',
    text: 'Desiree comes back with 110K EUR. I accept.',
    people: ['Desiree'],
  },
  {
    date: d(10, 9),
    kind: 'promise',
    title: '“Early next week”',
    text: "Desiree says she'll send the work contract to be signed and sent to the agency early next week.",
    people: ['Desiree'],
  },
  {
    date: d(10, 12),
    kind: 'holiday',
    title: 'Surprise! Holiday #2',
    text: 'Desiree goes on another two-week holiday. I call her boss. Daniel in the UK is assigned to my case.',
    people: ['Desiree', "Desiree's boss", 'Daniel'],
  },
  {
    date: d(10, 14),
    kind: 'progress',
    title: 'A contract appears',
    text: "Daniel gets access to the work contract and sends it to Jan and me to sign. A couple of items are wrong, so Daniel asks PeopleOps to fix them.",
    people: ['Daniel', 'Jan', 'PeopleOps'],
  },
  {
    date: d(10, 15),
    kind: 'stall',
    title: 'Jan doesn’t sign',
    text: 'The contract is fixed, but Jan has to re-sign it before I get it. Jan doesn’t sign it.',
    people: ['Jan', 'PeopleOps'],
    signature: 1,
  },
  {
    date: d(10, 16),
    kind: 'stall',
    title: 'Jan still doesn’t sign',
    text: 'Daniel allegedly pings him.',
    people: ['Jan', 'Daniel'],
    signature: 2,
  },
  {
    date: d(10, 19),
    kind: 'stall',
    title: 'Jan still doesn’t sign',
    text: 'Daniel and Tom both ping him.',
    people: ['Jan', 'Daniel', 'Tom'],
    signature: 3,
  },
  {
    date: d(10, 20),
    kind: 'ask',
    title: 'Jan signs (after I ask him myself)',
    text: "I message Jan directly. He finally signs. Daniel is now out of office on a trip to the Skopje office, but he's working on the forms for the agency.",
    people: ['Jan', 'Daniel'],
  },
  {
    date: d(10, 21),
    kind: 'progress',
    title: 'Off to the agency',
    text: "Daniel has everything he needs, and says it'll be in the agency's hands shortly.",
    people: ['Daniel'],
  },
  {
    date: d(10, 23),
    kind: 'milestone',
    title: 'The agency calls',
    text: 'Mahnaz from the relocation agency asks for basics like my passport and CV, so she can work out which visa to apply for.',
    people: ['Mahnaz'],
  },
  {
    date: d(10, 26),
    kind: 'progress',
    title: 'EU Blue Card',
    text: 'Mahnaz recommends the EU Blue Card, which needs employment verification letters proving at least three years of IT experience. I request letters from BYU, Nexio, Truelist and RLDatix.',
    people: ['Mahnaz', 'BYU', 'Nexio', 'Truelist', 'RLDatix'],
  },
  {
    date: d(10, 27),
    kind: 'milestone',
    title: 'An actual miracle',
    text: 'All four letters arrive in one day and I submit them. RLDatix needs to sign one more document for Mahnaz.',
    people: ['BYU', 'Nexio', 'Truelist', 'RLDatix', 'Mahnaz'],
  },
  {
    date: d(10, 28),
    kind: 'milestone',
    title: 'Submitted to Germany',
    text: 'Mahnaz submits the application to the Federal Employment Agency (Bundesagentur für Arbeit). Pre-approval should take 1–3 weeks.',
    people: ['Mahnaz'],
  },
  {
    date: d(11, 4),
    kind: 'progress',
    title: 'Paperwork for the consulate',
    text: 'No pre-approval yet, but Mahnaz sends every document I’ll need for the visa application at the German Consulate in Los Angeles.',
    people: ['Mahnaz'],
  },
];

// Where the time went. Each phase runs until the next one starts.
export const PHASES = [
  { key: 'manager', label: 'Asking my manager', start: d(7, 7) },
  { key: 'hr', label: 'Waiting on HR', start: d(8, 28) },
  { key: 'contract', label: 'Contract & signature', start: d(10, 14) },
  { key: 'agency', label: 'Relocation agency', start: d(10, 23) },
  { key: 'gov', label: 'German government', start: d(10, 28) },
];

// Shaded day ranges in the calendar (inclusive).
export const RANGES = [
  { kind: 'holiday', from: d(8, 31), to: d(9, 9) },
  { kind: 'holiday', from: d(10, 12), to: d(10, 25) },
  { kind: 'signature', from: d(10, 15), to: d(10, 19) },
  { kind: 'gov', from: d(10, 28), to: null }, // open-ended until the visa arrives
];

export const PREAPPROVAL_WINDOW = { from: d(11, 4), to: d(11, 18) }; // 1–3 weeks after 28 Oct

export const STILL_AHEAD = [
  'Pre-approval from the Federal Employment Agency',
  'Visa appointment at the German Consulate in Los Angeles',
  'EU Blue Card issued',
  'Actually move',
];
